class AccountsCtrl{

    constructor($scope, $routeParams, $uibModal, $filter, ApiService, CONTENT_TYPE, $location, Notification, $rootScope, EVENTS) {

        this.$scope = $scope;
        this.$rootScope = $rootScope;

        $scope.pagination = {
            itemsPerPage: 25,
            page: 1
        };
        $scope.accounts = [];
        $scope.error = false;
        $scope.noResults = false;
        $scope.loading = true;
        this.$scope.isCopying = false;
        this.$scope.isDeleting = false;
        this.$scope.selectAll = false;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.accountId = $routeParams.accountId;
        this.ApiService = ApiService;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.contentType = CONTENT_TYPE.ACCOUNT;
        this.$location = $location;
        this.Notification = Notification;
        this.$scope.addAccount = this.addAccount.bind(this);
        this.$scope.refreshAccounts = this.refreshAccounts.bind(this);
        this.$scope.updateAccount = this.updateAccount.bind(this);
        this.$scope.deleteAccount = this.deleteAccount.bind(this);
        this.$scope.selectOrDeselectAll = this.selectOrDeselectAll.bind(this);
        this.$scope.deleteSelected = this.deleteSelected.bind(this); 
        this.$scope.copy = this.copy.bind(this);
        this.$scope.copySelected = this.copySelected.bind(this);
        this.$scope.sortTable = this.sortTable.bind(this);
        this.EVENTS = EVENTS;    

        this.$scope.clientId = null;
        this.$scope.clients = null;   
        this.$scope.tableSort = "name";   
        $scope.itemsSelected = false;
        $scope.selectedItems = {};

        $scope.$watch('selectedItems', (newVal) => {
            let selected = false;
            Object.keys(newVal).forEach(key => {
                if(newVal[key]) { selected = true; }
            });
            $scope.itemsSelected = selected;
        },  true);

        this.$scope.$watch('tableFilter', this.accountsFilter.bind(this));
        
        $rootScope.$watch("currentUser.selectedClientId", () => {            
            this.refreshAccounts();
        });

        $rootScope.$on(this.EVENTS.COPY_COMPLETE, (event, entity) => {
            if(entity.clientId == this.$scope.clientId) {
                this.refreshAccounts();
            }
            this.$scope.isCopying = false;
        });
    }

    copySelected() {
        let toCopy = [];

        $.each(this.$scope.selectedItems, (accountId, selected) => { 
            if(selected) {
                let account = this.$scope.accounts.filter(a => a.id == accountId)[0];
                toCopy.push(account);
            }
        });

        let multiple = true;

        if(toCopy.length == 1) { 
            toCopy = toCopy[0]; 
            multiple = false;
        }

        this.copy(toCopy, multiple);

    }

    sortTable(key) {
        if (this.$scope.tableSort === '-' + key) {
            this.$scope.tableSort = key;
        } else {
            this.$scope.tableSort = '-' + key;
        }
    }

    addAccount() {

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'accounts/add-accounts.html',
            controller: 'AddItemCtrl',
            resolve: {
            }
        });

        modalInstance.result.then((newItem) => {
            this.createAccount(newItem);
        }, () => {

        });

    }

    updateAccount(newItem) {
        let account = {
            accountId: newItem.id,
            name: newItem.name
        };

        this.ApiService.update(this.contentType, account)
            .then((response) => {
                this.refreshAccounts();
            }, (response) => {
                this.$scope.error = true;
        });
    }


    createAccount(newItem) {

        let account = {
            clientId: this.$rootScope.currentUser.selectedClientId,
            name: newItem.name
        };

        this.ApiService.create(this.contentType, account)
            .then((response) => {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Account "' + response.data.name + '" created.'});
                this.$location.path('/account/' + response.data.id);
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
            });
    }

    deleteAccount(account) {

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            this.ApiService.delete(this.contentType, account.id)
                .then((response) => {
                    this.refreshAccounts();
                    this.$scope.isDeleting = false;
                }, (response) => {
                    console.error(response);
                    this.$scope.error = true;
                    this.$scope.isDeleting = false;
                });
        }, () => this.$scope.isDeleting = false);
    }

    refreshAccounts() {

        this.$scope.noResults = false;
        this.$scope.loading = true;

        let queryString = "client=" + this.$rootScope.currentUser.selectedClientId;
        this.ApiService.list(this.CONTENT_TYPE.ACCOUNT, queryString )
            .then((response) => {
                this.$scope.accounts = response.data;
                this.accountsFilter();
                this.$scope.loading = false;
                if (this.$scope.accounts.length === 0) {
                    this.$scope.noResults = true;
                }
            }, (response) => {
                if (response.status === 404) {
                    this.$scope.noResults = true;
                } else {
                    console.error(response);
                    this.$scope.error = true;
                }
                this.$scope.loading = false;
            });

        let clientId = this.$rootScope.currentUser.selectedClientId;
        if (clientId === "*") {
            this.$scope.$emit(this.EVENTS.SET_TITLE, "Accounts | All clients");
        } else {
            this.ApiService.get(this.CONTENT_TYPE.CLIENT, clientId)
                .then((response) => {
                    this.$scope.$emit(this.EVENTS.SET_TITLE, "Accounts | " + response.data.name);
                }, (response) => console.error(response));
        }
        
        

    }

    accountsFilter() {
        let filtered = this.$filter('filter')(this.$scope.accounts, this.$scope.tableFilter);
        this.$scope.availableItems = filtered.length;
    }

    selectOrDeselectAll() {
        this.$scope.selectAll = ! this.$scope.selectAll;
    
        this.$scope.selectedItems = {};
        if(this.$scope.selectAll) {
            this.$scope.accounts.forEach(account => { 
                this.$scope.selectedItems[account.id] = true;
            });
        }
    }

    deleteSelected() {
        let toDelete = [];

        $.each(this.$scope.selectedItems, (accountId, selected) => { 
            if(selected) {
                let account = this.$scope.accounts.filter(a => a.id == accountId)[0];
                toDelete.push(account);
            }
        });
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            toDelete.forEach((account, i) => {
                this.ApiService.delete(this.contentType, account.id)
                    .then((response) => {
                        if(i == toDelete.length - 1) {
                            this.refreshAccounts();
                            this.$scope.isDeleting = false;
                        }
                    }, (response) => {
                        console.error(response);
                        this.$scope.error = true;
                        this.$scope.isDeleting = false;
                    });
            });
        },() => {
            this.$scope.isDeleting = false;
        });
    }

    copy(account, multiple) {

        this.$scope.isCopying = true;

        let titleName = "";

        if(!!!multiple) { 
            multiple = false; 
        }
        else if(!multiple) {
            titleName = account.name;
        }

        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'components/copy-entity-modal.html',
            controller: 'CopyEntityCtrl',
            resolve: {
                entity: () => account,
                multiple: () => multiple,
                title: () => "Choose an account to copy " + titleName + " to..."
            }
        });

        modalInstance.result.then(item => this.$scope.isCopying = false, () => this.$scope.isCopying = false);
    }

}

angular.module("cpm").controller("AccountsCtrl", ['$scope', '$routeParams', '$uibModal', '$filter', 'ApiService', 'CONTENT_TYPE', '$location', 'Notification', '$rootScope', 'EVENTS', AccountsCtrl]);
